<template lang="html">
  <b-navbar
    class="is-dark" wrapper-class="container"
    v-bind:class="{'is-mobile': isMobile}">
    <template #brand class="navbar-start">
      <b-navbar-item>
        <div class="top-logo" />
      </b-navbar-item>
    </template>
    <template #start v-if="currentUser">
      <b-navbar-item
        class="navbar-item"
        href="/orders"
        v-bind:class="{ is_active: menuItemIsActive('order_list') }"
        >Order list</b-navbar-item
      >
      <b-navbar-item
        href="/order/create"
        v-bind:class="{ is_active: menuItemIsActive('order_create') }"
        >Create new order</b-navbar-item
      >

    </template>
    <template #end v-if="currentUser">
      <div id="search-item" style="margin-right: 6px">
        <b-field style="margin: 8px">
          <form v-on:submit="findOrder(orderReference)">
            <b-input
              placeholder="Search the order..."
              v-model="orderReference"
              custom-class="search-input"
            >
            </b-input>
          </form>
          <p class="control">
            <button
              class="button is-primary search-button"
              v-on:click="findOrder(orderReference)"
            >
              <b-icon pack="fas" icon="search" />
            </button>
          </p>
        </b-field>
      </div>
      <div
        id="navbarExampleTransparentExample"
        v-bind:class="{ 'is-active': IsActive, 'navbar-menu': !isMobile, 'is-mobile': isMobile}"
      >
        <template v-if="currentUser">
          <div class="navbar-item text-white">
            <b-icon pack="fas" icon="user-circle" /> &nbsp;
            {{ currentUser.user.email }}
          </div>
          <b-navbar-item
            class="navbar-item logout-btn"
            href="#"
            @click.prevent="logout"
            title="Logout"
          >
            <b-icon pack="fas" icon="sign-out-alt"
              :class="{ 'text-white': isMobile }" />
            <span v-if="isMobile" class="text-white">Logout</span>
          </b-navbar-item>
        </template>
      </div>
    </template>

    <template #end v-else>
      <b-navbar-item class="navbar-item login-btn">
        <a class="button color-blue" @click.prevent="login">
          <b-icon pack="fas" icon="user-circle" />
          <span>Login</span>
        </a>
      </b-navbar-item>
    </template>
  </b-navbar>
</template>

<script>
import Search from '@/components/Search'
import { mapGetters } from 'vuex'
import router from '@/router'

export default {
  name: 'Navbar',
  components: {
    Search
  },

  data () {
    return {
      orderReference: '',
      IsActive: false,
      isMobile: false
    }
  },

  created () {
    if (this.$route.params.reference) {
      this.orderReference = this.$route.params.reference
    }
  },

  computed: {
    ...mapGetters({ currentUser: 'cpAuth/currentUser' })
  },

  beforeDestroy () {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true })
    }
  },

  mounted () {
    this.onResize()
    window.addEventListener('resize', this.onResize, { passive: true })
  },

  methods: {
    menuItemIsActive (routeName) {
      return routeName === this.$route.name
    },

    navigate (event) {
      var target = event.currentTarget
      var route = target.getAttribute('href')
      router.push(route)
    },

    findOrder (orderReference) {
      if (orderReference) {
        router.push('/order/' + encodeURIComponent(orderReference))
      }
    },

    onResize () {
      this.isMobile = window.innerWidth <= 1024
    }
  }
}
</script>
